import { GoogleMap } from '../../components/map/map';
import { arrayAny } from '../../utils/arrayUtils';
import { googleMapsConfig } from '../../app';

export const LandlordMapTab = ({ propertyDocs, landlord }) => {

    const tabName = "Map";

    const mapConfig = (propertyDoc) => {
        return {
            className: "h-100 w-100",
            style: { height: '100vh', width: '100%' },
            apiKey: googleMapsConfig.apiKey,
            center: {
                lat: propertyDoc.coordinates.latitude,
                lng: propertyDoc.coordinates.longitude
            },
            zoom: 10
        }
    };

    const markers = () => {

        const markers = propertyDocs && arrayAny(propertyDocs) ? propertyDocs.filter(d => d && d.coordinates) : [];

        const result = markers.map(pd => {
            return {
                name: pd.property.name,
                navLink: `/property/detail/${pd.id}`,
                icon: 'fa fa-home',
                ...mapConfig(pd)
            }
        });

        return result;

    };

    return arrayAny(propertyDocs) && (
        <>
            <h3 className="mt-10px">{tabName} of properties for {landlord.displayName}</h3>
            <div key={tabName}>
                <GoogleMap {...mapConfig(landlord)} // Centre on Landlord HQ position, but plot markers for each property
                    markers={[].concat(markers(), {
                        name: 'HQ',
                        navLink: `/landlords/detail/${landlord.id}`,
                        icon: 'fa fa-home',
                        background: "red",
                        ...mapConfig(landlord)
                    })}>
                </GoogleMap>
            </div>
        </>
    );
}